export default function About() {
  return (
    <section id="about" className="relative py-32 bg-gradient-to-br from-[#3D2817] to-[#1A0F0A] overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="flex items-center gap-20">
          <div className="flex-1">
            <div className="inline-block mb-8 px-4 py-2 bg-[#FFE5E5]/10 rounded">
              <span className="text-[#FFE5E5] text-xs font-medium tracking-[2px] uppercase">
                // Who We Are
              </span>
            </div>

            <h2 className="mb-6">
              <div className="text-white text-[80px] font-bold leading-[1.1] tracking-tight">
                BRIMA SERVICOS
              </div>
              <div className="text-white/70 text-[40px] font-light leading-[1.2] tracking-wide">
                DE COBRANCA LTDA
              </div>
            </h2>

            <div className="space-y-10 text-[#F5EDE4] text-lg leading-[1.8] max-w-[90%]">
              <p>
                Founded with a mission to democratize digital privacy, BRIMA SERVICOS DE COBRANCA LTDA stands at the forefront of VPN technology innovation. We believe that online security and freedom are fundamental rights that should be accessible to everyone.
              </p>
              <p>
                Our team of cybersecurity experts and network engineers has developed a robust VPN infrastructure that combines cutting-edge encryption protocols with lightning-fast connection speeds. We don't just protect your data—we ensure your online experience remains seamless and unrestricted.
              </p>
              <p>
                Based in Brazil, we serve clients worldwide with our commitment to zero-logging policies and complete transparency. Your privacy is not just our promise—it's our foundation. We never track, store, or share your online activities.
              </p>
              <p>
                With BRIMA, you're not just getting a VPN service; you're joining a movement that champions digital freedom, privacy rights, and unrestricted access to information across the globe.
              </p>
            </div>
          </div>

          <div className="w-[500px] h-[500px] flex-shrink-0">
            <div className="w-full h-full rounded-[20px] overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.4)]">
              <img
                src="https://public.readdy.ai/ai/img_res/8c1acde7170869f7f87feaba62737b62.jpg"
                alt="Network Infrastructure"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="mt-24 flex items-center justify-between border-t border-white/10 pt-16">
          <div className="flex flex-col items-start">
            <div className="text-white text-[140px] font-serif font-bold leading-none">
              2025
            </div>
            <div className="text-white/60 text-base tracking-[3px] uppercase mt-2">
              Established
            </div>
          </div>

          <div className="flex flex-col items-center">
            <div className="w-16 h-16 flex items-center justify-center mb-4">
              <i className="ri-global-line text-5xl text-[#00D9FF]"></i>
            </div>
            <div className="text-white text-xl font-semibold tracking-wide">
              GLOBAL COVERAGE
            </div>
          </div>

          <div className="flex flex-col items-center">
            <div className="w-16 h-16 flex items-center justify-center mb-4">
              <i className="ri-shield-check-line text-5xl text-[#00D9FF]"></i>
            </div>
            <div className="text-white text-xl font-semibold tracking-wide">
              MILITARY-GRADE ENCRYPTION
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
